import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { ThreadsyncService } from "../../../shared-services/threadsync.service";
import {
    Cache,
    DoubleSide,
    FileLoader,
    Frustum,
    ImageUtils,
    Matrix4,
    Mesh,
    MeshBasicMaterial,
    PerspectiveCamera,
    PlaneGeometry,
    Raycaster,
    Scene,
    SphereGeometry,
    Spherical,
    Vector2,
    Vector3,
    WebGLRenderer
} from 'three'
import { MathUtils } from 'three';
import { Interaction } from 'three.interaction';

import { CSS2DObject, CSS2DRenderer } from "three/examples/jsm/renderers/CSS2DRenderer";
import { GlobalDataService } from "../../../shared-services/global-data.service";
import { ApiConfigService } from "../../../shared-services/api-config.service";
import { HotSpot } from '../../../dtos/hotSpot';
import { HotSpotTranslation } from '../../../dtos/hotSpot';
import { MonumentTranslation } from '../../../dtos/monumentDto';
import { debounceTime } from 'rxjs/operators';
import { tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { ResizeSensor } from 'css-element-queries';
import { ThreeService } from '../../../layout/remote/services/three.service';
import { BufferGeometry } from 'three';
import { Line } from 'three';
import { LineBasicMaterial } from 'three';

declare var WEBGL;

@Component({
    selector: 'app-panorama-container',
    templateUrl: './panorama-container.component.html',
    styleUrls: ['./panorama-container.component.scss']
})
export class PanoramaContainerComponent implements OnDestroy, AfterViewInit, OnChanges {

    public static PREV_LON = null;
    public static PREV_LAT = null;


    public static LON = null;
    public static LAT = null;

    public static FOV = null;

    public static MULTIPLY_FACTOR_TOUCH = 40; // prev was 80 and was too fast
    public static MULTIPLY_FACTOR_ΖOOΜ = 0.011; // prev was 0.02

    @ViewChild('panoramacontainer') public panoramacontainer: ElementRef;

    @Input() panoramic: any;
    @Input() panoramichotspots: any;


    @Input() rotateX: any;
    @Input() rotateY: any;

    @Input() north_rotateY: any;

    @Input() haveLabels: boolean;

    @Input() heightOffset = 0;

    @Input() autoRotateCamera = false;

    @Input() materialOpacity = false;
    @Input() editMode = false;

    @Input() parentId = 0;

    @Input() showCompass;

    @Input() enableCaching: boolean;
    @Input() enableMouse: boolean = true;
    @Input() guideAction;


    @Output() pinClickCallback = new EventEmitter();
    @Output() pinConfigurationChange = new EventEmitter();
    @Output() panoramaConfigurationChange = new EventEmitter();
    @Output() sceneErrorCallback = new EventEmitter();
    @Output() compassRotation = new EventEmitter();
    @Output() rotateXChange = new EventEmitter();
    @Output() rotateYChange = new EventEmitter();

    public animationFrameId: any;
    public camera;
    public renderer;
    public labelRenderer;
    public scene;
    public container;
    public canvas;
    public interaction;
    public moving;
    public hotSpotObjects = [];
    public isUserInteracting = false;
    public onMouseDownMouseX = 0;
    public onMouseDownMouseY = 0;
    public onMouseDownLon = 0;
    public onMouseDownLat = 0;
    public lon = -177.77777777777777;
    public lat = -22.49999999999999;
    public theta = 0;
    public hotSpots: any;
    public hypo = undefined;
    panoramicgeometry = new SphereGeometry(500, 60, 40);

    webglContextVersion = 'webgl2';
    scenePanorama: any;
    hotSpotTypes = [
        {
            enum: "NAVIGATION",
            name: "Πλοήγηση"
        },
        {
            enum: "INFO",
            name: "Πληροφορίες"
        },
        {
            enum: "VIDEO",
            name: "Βίντεο"
        }, {
            enum: "IMAGE",
            name: "Εικόνα"
        },
        {
            enum: "SOUND",
            name: "Ήχος"
        }
    ];
    componentType = [
        {
            enum: "MONUMENT",
            name: "Μνημείο"
        },
        {
            enum: "SITE",
            name: "Αρχαιολογικός Χώρος"
        },
        {
            enum: "PANORAMA",
            name: "Πανοραμική φωτογραφία"
        }
    ]
    private componentDocument;
    private rayCaster = new Raycaster();
    private mousePosition = new Vector2();
    private mouseDelta = 0;
    private resizeSensor;

    constructor(
        public translate: TranslateService,
        public threadSyncService: ThreadsyncService,
        private globalData: GlobalDataService,
        private apiConfigService: ApiConfigService,
        private elRef: ElementRef,
        private threeService: ThreeService) {
        this.panoramicgeometry.scale(-1, 1, 1);
        this.componentDocument = this.elRef.nativeElement;
    }

    ngAfterViewInit(): void {
        this.hotSpots = this.panoramichotspots;
        if (this.hotSpots && this.hotSpots.length > 0) {
            PanoramaContainerComponent.PREV_LON = PanoramaContainerComponent.LON;
            PanoramaContainerComponent.PREV_LAT = PanoramaContainerComponent.LAT;
        }
        if (ResizeSensor) {
            this.resizeSensor = new ResizeSensor(this.panoramacontainer.nativeElement, this.onWindowResize.bind(this));
        }
        this.init();
        this.animate();
    }


    ngOnDestroy(): void {
        // console.log('PanoramaContainer ngOnDestroy thread ready to destroy');
        if (!this.hotSpots || this.hotSpots.length == 0) {
            PanoramaContainerComponent.LON = PanoramaContainerComponent.PREV_LON;
            PanoramaContainerComponent.LAT = PanoramaContainerComponent.PREV_LAT;
        }
        this.destroyScene();

        // console.log('PanoramaContainer destroyed. thread ready');
        this.threadSyncService.setSync(true);
        Cache.clear();
        if (this.resizeSensor) {
            this.resizeSensor.detach();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (changes.panoramic && changes.panoramic.previousValue && changes.panoramic.currentValue !== changes.panoramic.previousValue) {
            //console.log(changes.panoramic.currentValue);
            this.clearUpPanoramic();
            this.loadEquirectangular(0);
            this.hotSpotObjects = [];
            this.hotSpots = [];
            this.addHotSpots();
        }
        if (changes.panoramichotspots && changes.panoramichotspots.currentValue !== changes.panoramichotspots.previousValue && !changes.panoramic) {

            if (!Array.isArray(changes.panoramichotspots.currentValue)) {
                this.hotSpots = [changes.panoramichotspots.currentValue];
            } else {
                this.hotSpots = changes.panoramichotspots.currentValue;
            }

            this.clearUpPanoramic();

            this.hotSpotObjects = [];
            this.addHotSpots();
        }
        if ((changes.rotateX && !changes.rotateX.isFirstChange()) || (changes.rotateY && !changes.rotateY.isFirstChange())) {
            this.setUpRotation();
        }
    }


    loadEquirectangular(index) {
        const obj = this.scene.getObjectByName('panoramic');
        if (obj) {
            this.scene.remove(obj);
        }

        while (this.scene.children.length) {
            this.scene.remove(this.scene.children[0]);
        }
        if (this.panoramic) {
            let panoramicMaterial;
            const isBlob = this.panoramic && this.panoramic.includes("blob");
            const srcLow = isBlob ? this.panoramic : this.apiConfigService.getUrl() + this.panoramic.replace('.jpg', '-low.jpg');
            const srcHigh = isBlob ? this.panoramic : this.apiConfigService.getUrl() + this.panoramic;
            this.fileLoader(srcLow, () => {
                panoramicMaterial = new MeshBasicMaterial({
                    map: this.threeService.textureLoader.load(srcLow, () => {
                        this.fileLoader(srcHigh, () => {
                            this.threeService.textureLoader.load(srcHigh, (texture) => {
                                panoramicMaterial.map = texture;
                            })
                        })
                    })
                });
                if (this.materialOpacity) {
                    panoramicMaterial.transparent = true;
                    panoramicMaterial.opacity = 0.6;
                }

                let panoramicMesh = new Mesh(this.panoramicgeometry, panoramicMaterial);
                panoramicMesh.name = 'panoramic';
                this.scene.add(panoramicMesh);
                if (!this.enableCaching) {
                    Cache.clear();
                }
                this.setUpRotation();
            });

        }

    }

    public init() {

        if (WEBGL.isWebGL2Available() === true) {
            this.webglContextVersion = 'webgl2';
        } else if (WEBGL.isWebGLAvailable() === true) {
            this.webglContextVersion = 'webgl';
        } else {
            console.error(WEBGL.getWebGLErrorMessage());
            this.sceneErrorCallback.emit('webgl not available');
            return;
        }

        const context = this;
        context.container = this.panoramacontainer.nativeElement;
        context.canvas = document.createElement('canvas');
        let calculatedHeight = this.panoramacontainer.nativeElement.clientHeight - this.heightOffset;

        const ctx = context.canvas.getContext(this.webglContextVersion);

        if (!ctx) {
            console.error(this.webglContextVersion + ' context not created');
            this.threadSyncService.setSync(true);
            this.sceneErrorCallback.emit('webl12 context not created');
            return;
        }

        context.labelRenderer = new CSS2DRenderer();
        context.labelRenderer.setSize(context.container.clientWidth, calculatedHeight);
        context.labelRenderer.domElement.style.position = 'absolute';
        context.labelRenderer.domElement.style.top = 0;
        context.labelRenderer.autoClear = false;
        context.container.appendChild(context.labelRenderer.domElement);


        try {
            context.renderer = new WebGLRenderer({canvas: context.canvas, context: ctx});
        } catch (e) {
            this.threadSyncService.setSync(true);
            this.sceneErrorCallback.emit('renderer not created: ' + e);
            return;
        }

        context.renderer.setSize(context.container.clientWidth, calculatedHeight);
        context.renderer.setPixelRatio(window.devicePixelRatio);
        context.renderer.setClearColor(0x000000, 1);
        context.renderer.autoClear = false;
        context.container.appendChild(context.renderer.domElement);


        context.scene = new Scene();
        this.scenePanorama = context.scene;
        // scene = scenePanorama;

        if (this.hotSpots) {
            context.camera = new PerspectiveCamera(65, context.container.clientWidth / calculatedHeight, 1, 1100);
        } else {
            // start further away on single panoramics
            context.camera = new PerspectiveCamera(65, context.container.clientWidth / calculatedHeight, 1, 1100);
        }
        context.camera.target = new Vector3(0, 0, 0);

        context.loadEquirectangular(0);
        if (this.enableMouse) {
            context.initializeClickHandling();
        }

        context.addHotSpots();
        context.checkSceneReady();

        this.setUpRotation();
    }

    public checkSceneReady() {
        const obj = this.scene.getObjectByName('panoramic');
        if (!obj) {
            setTimeout(() => {
                this.checkSceneReady();
            }, 100);
        }
        setTimeout(() => {
            this.displayHotSpots();
            //this.loader.hide();
        }, 500);
    }

    public displayHotSpots() {
        if (this.hotSpotObjects && this.hotSpotObjects.length > 0) {
            const containerlbs = this.componentDocument.querySelector('#containerlbs');
            if (containerlbs) {
                containerlbs.style.visibility = 'visible';
            }
            this.hotSpotObjects.forEach(hotSpotObject => {
                hotSpotObject.sprite.visible = true;
            });
        }
    }

    public animateHotSpotObjects() {
        this.hotSpotObjects.forEach(el => {
            const originalScale = parseFloat(el.hotSpot.scale);
            const currentScale = parseFloat(el.sprite.scale.x);
            const scaleRate = originalScale / 1000;

            if (el.ascend) {

                el.sprite.scale.set(el.sprite.scale.x + scaleRate, el.sprite.scale.y + scaleRate, el.sprite.scale.z + scaleRate);
                if (currentScale >= originalScale * 1.02) {
                    el.ascend = false;
                }
            } else {
                el.sprite.scale.set(el.sprite.scale.x - scaleRate, el.sprite.scale.y - scaleRate, el.sprite.scale.z - scaleRate);
                if (currentScale <= originalScale * 0.98) {
                    el.ascend = true;
                }
            }
        });
    }

    public animate() {
        const context = this;
        if (context.scene) {
            if (context.isUserInteracting === false && context.autoRotateCamera) {
                context.lon += 0.1;
            }
            requestAnimationFrame(context.animate.bind(context));
            context.lat = Math.max(-85, Math.min(85, context.lat));
            let phi = MathUtils.degToRad(90 - context.lat);
            context.theta = MathUtils.degToRad(context.lon);
            context.camera.target.x = 500 * Math.sin(phi) * Math.cos(context.theta);
            context.camera.target.y = 500 * Math.cos(phi);
            context.camera.target.z = 500 * Math.sin(phi) * Math.sin(context.theta);
            context.camera.lookAt(context.camera.target);
            // context.animateHotSpotObjects();
            context.udateLabelsPositions();
            if (context.showCompass) {
                context.compassSet();
            }
            if (context.labelRenderer) {
                context.labelRenderer.render(context.scene, context.camera);
            } else {
                cancelAnimationFrame(this.animationFrameId);
                return;
            }

            if (context.renderer) {
                context.renderer.render(context.scene, context.camera);
            } else {
                cancelAnimationFrame(this.animationFrameId);
                return;
            }
        }
    }

    public addHotSpots() {
        if (this.hotSpots === undefined) {
            this.hotSpots = [];
            return;
        }
        const context = this;
        ImageUtils.crossOrigin = '';
        for (const hotSpot of context.hotSpots) {
            if (hotSpot) {

                if (!hotSpot.hotSpot.hot_size) {
                    hotSpot.hotSpot.hot_size = 54;
                }

                if (!hotSpot.hotSpot.hot_x) {
                    hotSpot.hotSpot.hot_x = 1000;
                }

                if (!hotSpot.hotSpot.hot_y) {
                    hotSpot.hotSpot.hot_y = 1000;
                }
                if (!hotSpot.hotSpot.hot_z) {
                    hotSpot.hotSpot.hot_z = 1000;
                }

                const position = {
                    x: hotSpot.hotSpot.hot_x,
                    y: hotSpot.hotSpot.hot_y,
                    z: hotSpot.hotSpot.hot_z
                }
                const sprite = this.createSprite('hot' + hotSpot.id, position);


                let label = this.createHotSpotLabel(hotSpot);
                context.scene.add(sprite);
                let spriteLabel = new CSS2DObject(label);
                spriteLabel.name = 'spr' + hotSpot.id;
                spriteLabel.position.set(0, 0, 0);
                sprite.add(spriteLabel);

                context.hotSpotObjects.push({hotSpot, sprite, ascend: false, label});
            }
        }
    }

    public udateLabelsPositions() {
        this.hotSpotObjects.forEach(hotSpotObject => {
            this.camera.updateMatrix();
            this.camera.updateMatrixWorld();
            let frustum = new Frustum();
            frustum.setFromProjectionMatrix(new Matrix4().multiplyMatrices(this.camera.projectionMatrix, this.camera.matrixWorldInverse));
            var pos = new Vector3(hotSpotObject.hotSpot.hotSpot.hot_x, hotSpotObject.hotSpot.hotSpot.hot_y, hotSpotObject.hotSpot.hotSpot.hot_z);
            if (frustum.containsPoint(pos)) {
                if (this.haveLabels) {
                    hotSpotObject.label.style.visibility = 'visible';
                } else {
                    hotSpotObject.label.style.visibility = 'hidden'
                }
            } else {
                hotSpotObject.label.style.visibility = 'hidden'
            }
        });
    }

    public getLabelCoords(element) {

        const screenVector = new Vector3();
        element.localToWorld(screenVector);

        screenVector.project(this.camera);

        const posx = Math.round((screenVector.x + 1) * this.renderer.domElement.offsetWidth / 2);
        const posy = Math.round((1 - screenVector.y) * this.renderer.domElement.offsetHeight / 2);

        return {x: posx, y: posy};
    }

    public dispose() {
        this.sceneTraverse(this.scene, o => {
            if (o.geometry) {
                o.geometry.dispose();
                o.geometry = undefined;
            }

            if (o.material) {
                if (o.material.length) {
                    for (let i = 0; i < o.material.length; ++i) {
                        o.material[i].dispose();
                        o.material[i] = undefined;
                    }
                } else {
                    o.material.dispose();
                    o.material = undefined;
                }
            }
        });
    }

    public destroyScene() {

        cancelAnimationFrame(this.animationFrameId);
        this.renderer && this.renderer.renderLists.dispose();
        this.renderer && this.renderer.dispose();
        this.renderer = undefined;
        this.labelRenderer = undefined;

        this.dispose();
        this.deleteChildren(this.scene);
        if (this.renderer) {
            this.renderer.dispose();
        }
        this.camera = undefined;

        if (this.interaction) {
            this.interaction.removeEvents();
        }
        this.interaction = undefined;

        /*if (this.scene && this.scene.dispose()) {
            //this.scene.dispose();
        }*/
        this.scene = undefined;
        this.scenePanorama = undefined;

        if (this.canvas) {
            const ctx3d = this.canvas.getContext(this.webglContextVersion);
            if (ctx3d) {
                try {
                    ctx3d.getExtension('WEBGL_lose_context').loseContext();
                    // console.log('panoramic WEBGL12_lose_context');
                } catch (err) {
                    // console.error('panoramic Cant Lose Context WEBGL12');
                }
            } else {
                // console.error('panoramic  No context found to lose WEBGL12');
            }

            this.canvas = undefined;
        }
        // context.container = document.getElementById('container');
        if (this.container) {
            this.container.innerHTML = '';
        }
    }

    // recursive delete of all 3d objects
    public deleteChildren(object) {
        if (object) {
            if (object.children) {
                for (let i = object.children.length - 1; i >= 0; i--) {
                    this.deleteChildren(object.children[i]);
                    if (object.children[i].dispose !== undefined) {
                        // console.log('disposing ' + object.children[i]);
                        object.children[i].dispose();
                    }
                    object.remove(object.children[i]);
                }
            }
        }
    }

    public initializeClickHandling() {
        const context = this;
        context.interaction = new Interaction(context.labelRenderer, context.scene, context.camera);
        context.scene.on('mousedown', ev => {
            context.mouseDelta = new Date().getTime();
            // console.log('touchstart');
            if (ev.data.originalEvent.targetTouches && ev.data.originalEvent.targetTouches.length === 2) {
                // get original x,y for both touches
                context.hypo = [
                    ev.data.originalEvent.touches[0].screenX,
                    ev.data.originalEvent.touches[0].screenY,
                    ev.data.originalEvent.touches[1].screenX,
                    ev.data.originalEvent.touches[1].screenY,
                ];
            } else {
                context.onPointerStart(ev);
            }
        });
        context.scene.on('mousemove', ev => {
            // console.log('touchmove');
            context.moving = true;
            if (ev.data.originalEvent.targetTouches && ev.data.originalEvent.targetTouches.length === 2) {
                const originalX1 = context.hypo[0];
                const originalY1 = context.hypo[1];
                const originalX2 = context.hypo[2];
                const originalY2 = context.hypo[3];

                const newX1 = ev.data.originalEvent.touches[0].screenX;
                const newY1 = ev.data.originalEvent.touches[0].screenY;
                const newX2 = ev.data.originalEvent.touches[1].screenX;
                const newY2 = ev.data.originalEvent.touches[1].screenY;

                const origX1X2 = (originalX1 - originalX2);
                const newX1X2 = (newX1 - newX2);
                const origY1Y2 = (originalY1 - originalY2);
                const newY1Y2 = (newY1 - newY2);

                const origHypo = Math.hypot(
                    origX1X2,
                    origY1Y2);

                const newHypo = Math.hypot(
                    newX1X2,
                    newY1Y2);

                let newFieldOfView;

                const dist = origHypo - newHypo;
                // newFieldOfView = this.camera.fov + (dist * 0.01);
                newFieldOfView = this.camera.fov + (dist * PanoramaContainerComponent.MULTIPLY_FACTOR_ΖOOΜ);

                if (newFieldOfView > 45 && newFieldOfView < 110) {
                    this.camera.fov = newFieldOfView;
                    PanoramaContainerComponent.FOV = this.camera.fov;
                }

                this.camera.updateProjectionMatrix();

            } else {
                context.onPointerMove(ev);
            }
        });
        context.scene.on('mouseup', ev => {
            // console.log('touchend');
            if (context.moving) {
                context.moving = false;
            }
            context.hypo = undefined;
            context.onPointerUp();
            const delta = Math.abs(new Date().getTime() - context.mouseDelta);
            setTimeout(() => {
                let pos = this.getClicked3DPoint(ev.data.originalEvent);
                if (ev && this.hotSpotObjects.length > 0 && !context.moving && this.editMode && delta <= 300) {
                    this.hotSpotObjects[0].sprite.position.x = pos.x;
                    this.hotSpotObjects[0].sprite.position.y = pos.y;
                    this.hotSpotObjects[0].sprite.position.z = pos.z;
                    this.hotSpotObjects[0].sprite.lookAt(this.camera.position);
                    this.hotSpots[0].hotSpot.hot_x = pos.x;
                    this.hotSpots[0].hotSpot.hot_y = pos.y;
                    this.hotSpots[0].hotSpot.hot_z = pos.z;
                    this.pinConfigurationChange.emit(this.hotSpots[0]);
                }
                if(this.guideAction && this.guideAction !=='mouse' && delta <= 300){
                    alert(this.guideAction + ' '+ JSON.stringify(pos));
                }
            }, 10)
        });
        context.scene.on('mouseout', ev => {
            // console.log('touchend');
            if (context.moving) {
                context.moving = false;
            }
            context.hypo = undefined;
            context.onPointerUp();
        });

        context.scene.on('click', ev => {


        })

    }

    public onPointerStart(event) {
        const context = this;
        context.isUserInteracting = true;
        const clientX = event.data.global.x;
        const clientY = event.data.global.y;

        context.onMouseDownMouseX = clientX;
        context.onMouseDownMouseY = clientY;
        context.onMouseDownLon = context.lon;
        context.onMouseDownLat = context.lat;
        of(event).pipe(
            debounceTime(300),
            tap(() => {
                setTimeout(() => {
                    const hotSpotPins = document.getElementsByClassName("hotSpot");
                    for (let i = 0; i <= hotSpotPins.length; i++) {
                        if (hotSpotPins[i]) {
                            hotSpotPins[i].classList.add('disableEvents');
                        }
                    }
                }, 200)
            })
        )
            .subscribe()
            .unsubscribe();

    }

    public onPointerMove(event) {
        const context = this;

        if (context.isUserInteracting === true) {

            const clientX = event.data.global.x;
            const clientY = event.data.global.y;
            context.lon = (context.onMouseDownMouseX - clientX) * PanoramaContainerComponent.MULTIPLY_FACTOR_TOUCH + context.onMouseDownLon;
            context.lat = (context.onMouseDownLat - (clientY - context.onMouseDownMouseY) * PanoramaContainerComponent.MULTIPLY_FACTOR_TOUCH);

            // if (this.panoramichotspots) {
            PanoramaContainerComponent.LON = context.lon;
            PanoramaContainerComponent.LAT = context.lat;
            // }
            this.rotateXChange.emit(context.lat);
            this.rotateYChange.emit(context.lon);
        }
    }

    public onPointerUp() {
        const context = this;
        context.isUserInteracting = false;
        const hotSpotPins = document.getElementsByClassName("hotSpot");
        for (let i = 0; i <= hotSpotPins.length; i++) {
            if (hotSpotPins[i]) {
                hotSpotPins[i].classList.remove('disableEvents');
            }
        }
    }

    onWindowResize(event) {
        let calculatedHeight = this.panoramacontainer.nativeElement.clientHeight;
        if (this.camera) {
            this.camera.aspect = this.panoramacontainer.nativeElement.clientWidth / calculatedHeight;
            this.camera.updateProjectionMatrix();
        }

        if (this.renderer) {
            this.renderer.setSize(this.panoramacontainer.nativeElement.clientWidth, calculatedHeight);
        }

        if (this.labelRenderer) {
            this.labelRenderer.setSize(this.panoramacontainer.nativeElement.clientWidth, calculatedHeight);
        }
    }

    public setFov(event) {
        this.camera.updateProjectionMatrix();
    }

    changeHeight($event) {
        this.componentDocument.getElementsByClassName('labelInner')[0].style.height = $event.target.value + "px";
        this.hotSpots[0].hotSpot.hot_size = Number($event.target.value);
        this.pinConfigurationChange.emit(this.hotSpots[0]);
    }

    changeOrientation($event) {
        let isLeft = $event.target.value === 'left';
        if (isLeft) {
            this.componentDocument.getElementsByClassName('labelPanorama')[0].classList.add('left');
        } else {
            this.componentDocument.getElementsByClassName('labelPanorama')[0].classList.remove('left');
        }
        this.hotSpots[0].hotSpot.rotation = $event.target.value;
        this.pinConfigurationChange.emit(this.hotSpots[0]);
    }

    changeTranslation($event) {
        let spanElements = this.componentDocument.getElementsByClassName('labelPanorama')[0].getElementsByTagName("span");
        spanElements[0].innerText = this.globalData.getObjectTranslation(this.hotSpots[0].panoramaHotspotsTranslationList, 'name');
        this.pinConfigurationChange.emit(this.hotSpots[0]);
    }

    changeNoPanoramicInformation() {
        this.pinConfigurationChange.emit(this.hotSpots[0]);
    }

    deletePanoramaPoint() {
        this.hotSpots[0].delete = true;
        this.pinConfigurationChange.emit(this.hotSpots[0]);
    }

    cameraSave(compass?) {
        const configuration = {
            camera: [compass ? null : PanoramaContainerComponent.LAT, PanoramaContainerComponent.LON],
            northView: this.north_rotateY
        }
        this.panoramaConfigurationChange.emit(configuration);
    }

    onComponentSelected(event) {
        let hotSpot: HotSpot = this.hotSpots[0];
        if (hotSpot.panoramaComponent === 'MONUMENT') {
            hotSpot.panoramaHotspotsTranslationList.forEach((hotSpotTranslation: HotSpotTranslation) => {
                const monumentLanguage = event.monumentTranslations.find((el: MonumentTranslation) => el.language.id === hotSpotTranslation.language.id);
                hotSpotTranslation.name = monumentLanguage.name;
            })
        }
    }

    private setUpRotation() {
        if (this.hotSpots && PanoramaContainerComponent.LON !== null) {
            this.lon = PanoramaContainerComponent.LON;
            this.lat = PanoramaContainerComponent.LAT;
        } else {
            if (this.rotateX && this.rotateY && this.rotateX != 0 && this.rotateY != 0) {
                this.lat = this.rotateX;
                this.lon = this.rotateY;
            } else {
                this.lon = -177.77777777777777;
                this.lat = -22.49999999999999;
            }
        }
    }

    private sceneTraverse(obj: any, fn: any): void {
        if (!obj) {
            return;
        }
        fn(obj);
        if (obj.children && obj.children.length > 0) {
            obj.children.forEach(o => {
                this.sceneTraverse(o, fn);
            });
        }
    }

    private fileLoader(src, callback) {
        const loader = new FileLoader();
        const cache = Cache;
        // Turn on shared caching for FileLoader, ImageLoader and TextureLoader
        cache.enabled = true;
        if (cache.get(src) && this.enableCaching) {
            callback(cache.get(src));
            this.isUserInteracting = false;
            return;
        }
        let tokenType = sessionStorage.getItem("tokenType");
        let accessToken = sessionStorage.getItem("accessToken");
        loader.setResponseType('blob');
        loader.requestHeader = {Authorization: tokenType + " " + accessToken};
        loader.load(
            src,
            (blob) => {
                // ObjectURLs should be released as soon as is safe, to free memory
                const image = <any>document.createElementNS('http://www.w3.org/1999/xhtml', 'img');
                const blobUrl = URL.createObjectURL(blob);
                image.onload = function () {
                    cache.add(src, image);
                    document.body.removeChild(image);
                    callback(image);
                    URL.revokeObjectURL(blobUrl);
                }.bind(this);

                image.src = blobUrl;
                image.style.visibility = 'hidden';
                document.body.appendChild(image);
            },
            (xhr) => {
                //console.log(`${xhr.loaded / xhr.total * 100}% loaded`);
            },
            (xhr) => {
                console.log('Error happened', xhr);
            },
        );
    }

    private getClicked3DPoint(evt) {
        evt.preventDefault();
        const leftOffset = this.canvas.getBoundingClientRect().left + document.documentElement.scrollLeft;
        const topOffset = this.canvas.getBoundingClientRect().top;
        this.mousePosition.x = ((evt.clientX - leftOffset) / this.canvas.width) * 2 - 1;
        this.mousePosition.y = -((evt.clientY - topOffset) / this.canvas.height) * 2 + 1;

        this.rayCaster.setFromCamera(this.mousePosition, this.camera);
        var intersects = this.rayCaster.intersectObjects(this.scene.children, true);

        if (intersects.length > 0)
            return intersects[0].point;
    };

    private clearUpPanoramic() {
        if (this.scene) {
            for (let i = this.scene.children.length - 1; i >= 0; i--) {
                const child = this.scene.children[i];
                if (child && child.name !== 'panoramic')
                    this.scene.remove(child);
            }
        }

        let elements: any = this.componentDocument.getElementsByClassName('hotSpot');
        for (let i = elements.length - 1; i >= 0; i--) {
            let element = elements[i];
            if (element.id.length > 0) {
                element.parentNode.removeChild(element);
            }
        }
    }

    private compassSet() {
        let dir = new Vector3();
        let sph = new Spherical();
        this.camera.getWorldDirection(dir);
        sph.setFromVector3(dir);
        const theta = MathUtils.degToRad(this.north_rotateY) - this.theta;
        document.getElementById('compass').style.transform = `rotate(${MathUtils.radToDeg(theta)}deg)`;
        this.compassRotation.emit(MathUtils.radToDeg(theta));
    }

    private createHotSpotLabel(hotSpot) {
        if (hotSpot.hotSpotType === "NAVIGATION" && hotSpot.panoramaComponent === 'MONUMENT') {
            return this.createMonumentLabel(hotSpot);
        } else if (hotSpot.hotSpotType === "NAVIGATION" && hotSpot.panoramaComponent === 'PANORAMA') {
            return this.helicopterLabel(hotSpot);
        } else if (hotSpot.hotSpotType === 'INFO') {
            return this.informationType(hotSpot);
        } else {
            return this.notAtype();
        }
    }

    private createMonumentLabel(hotSpot) {
        const labelsArray = [...this.componentDocument.getElementsByClassName('labelTemplate')]
            .filter((element) => {
                const label = element.getElementsByClassName('labelPanorama')[0];
                return label.innerText.length === 0;
            })

        const label: any = labelsArray[0].cloneNode(true);
        label.setAttribute('id', 'label' + hotSpot.id);
        let textOfLabel = this.globalData.getObjectTranslation(hotSpot.panoramaHotspotsTranslationList, 'name');
        let labelSpan = document.createElement("span");
        labelSpan.append(textOfLabel);
        const labelPanorama = label.getElementsByClassName('labelPanorama')[0]
        labelPanorama.append(labelSpan);
        labelPanorama.hotSpot = hotSpot;
        labelPanorama.addEventListener('click', this.monumentNavigation.bind(this), false);
        const labelInner = label.getElementsByClassName('labelInner')[0];
        labelInner.style.height = hotSpot.hotSpot.hot_size + 'px';
        if (hotSpot.hotSpot.rotation === 'left') {
            label.getElementsByClassName('labelPanorama')[0].classList.add("left");
        }
        return label;
    }

    private informationType(hotSpot) {
        const informationType = this.componentDocument.getElementsByClassName("infoTemplate")[0];
        const label: any = informationType.cloneNode(true);
        label.setAttribute("id", "info-" + hotSpot.id);
        const infoIcon = label.getElementsByClassName('infoIcon')[0];
        infoIcon.addEventListener('click', this.showInformationWindow.bind(this), false);
        const infoData = label.getElementsByClassName('infoData')[0];
        const closeButton = label.getElementsByClassName('closeButton')[0];
        closeButton.addEventListener('click', this.showInformationWindow.bind(this), false);
        infoData.innerHTML = this.globalData.getObjectTranslation(hotSpot.panoramaHotspotsTranslationList, 'name');
        return label;
    }

    private helicopterLabel(hotSpot) {
        const noType = this.componentDocument.getElementsByClassName("navigation")[0];
        const label: any = noType.cloneNode(true);
        label.setAttribute("id", "navigation-" + hotSpot.id);
        label.hotSpot = hotSpot;
        label.addEventListener('click', this.navigateToPanoramic.bind(this), false);
        return label;
    }

    private notAtype() {
        const noType = this.componentDocument.getElementsByClassName("noType")[0];
        const label: any = noType.cloneNode(true);
        label.setAttribute("id", "notype");
        return label;
    }

    private showInformationWindow(event) {
        const infoContainer = event.currentTarget.parentNode.className === 'infoContainer' ?
            event.currentTarget.parentNode :
            event.currentTarget.parentNode.getElementsByClassName('infoContainer')[0];
        if (infoContainer.style.display === 'block') {
            infoContainer.style.display = "none";
        } else {
            infoContainer.style.display = "block";
        }
    }

    private navigateToPanoramic(event) {
        this.clearUpPanoramic();
        const configuration = {
            hotSpot: event.currentTarget.hotSpot
        }
        PanoramaContainerComponent.LON = null;
        this.panoramaConfigurationChange.emit(configuration);
    }

    private createSprite(name, position: { x: number, y: number, z: number }) {
        const material = new MeshBasicMaterial({
            opacity: 0,
            side: DoubleSide,
            transparent: true
        });
        const planeGeometryOneOne = new PlaneGeometry(1, 1);
        const sprite = new Mesh(planeGeometryOneOne, material);
        const rotation = new Matrix4().makeRotationAxis(new Vector3(1, 0, 0), 1.57);
        sprite.rotation.setFromRotationMatrix(rotation);
        sprite.name = name;
        sprite.position.set(position.x, position.y, position.z);
        sprite.lookAt(this.camera.position);
        sprite.visible = true;
        return sprite;
    }

    private monumentNavigation(event) {
        const configuration = {
            hotSpot: event.currentTarget.hotSpot
        }
        this.panoramaConfigurationChange.emit(configuration);
    }

}
